import styled from "styled-components";

export const InputSingleFieldWrapper = styled.div`
  width: 50%;
  display: flex;
  padding-right: 8px;
  margin-bottom: 24px;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    margin: 24px 0 0 0;
    width: 100%;
    padding-right: 0;
  }
`
